module.exports = __webpack_public_path__ + "media/images/icon-thema-fail-c7183d74695f22dba033763c7b91038d.svg";